import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { RowActions, Report } from 'src/app/dashboard/admin/report/report';
import { BinMerchantProviderList } from '../services/bin-merchantProvider-list.service';
import { PinManagerData } from '../types';

@Component({
  selector: 'app-bin-merchant-providers-list',
  templateUrl: './bin-merchant-providers-list.component.html',
  styleUrls: ['./bin-merchant-providers-list.component.scss'],
})
export class BinMerchantProvidersListComponent implements OnInit {
  merchant: { name: string; id: number };
  data: { name: string; id: number }[];

  displayTableColumns: { [key: string]: string };
  properties = ['name'];

  selectFilters = [];
  columnTypes = {};
  itemsPerPage: number = 10;

  actions: RowActions[];
  totalRecords: number;
  requestBody: Report;

  constructor(
    private router: Router,
    private binMerchantProviderList: BinMerchantProviderList
  ) {
    this.displayTableColumns = {
      name: 'Provider',
    };

    this.actions = [
      {
        actionName: 'edit',
        actionType: 'icon',
        iconClass: 'fa fa-edit',
      },
    ];

    this.requestBody = {
      paginationOptions: {
        start: 0,
        limit: 10,
      },
      filterOptions: {},
    };

    const state = this.router.getCurrentNavigation()?.extras.state;
    this.merchant = state?.merchant ?? {
      name: null,
      id: null,
    };
  }

  get reportHeader(){
    return `${this.merchant.name} Providers List`
  }

  async ngOnInit() {
    if (!this.merchant.name || !this.merchant.id)
      await this.router.navigate(['admin/bin-providers']);
    await this.getProviders();
  }

  async getProviders() {
    const data = { count: 0, result: [{ name: 'test', id: 6 }] };
    this.totalRecords = data.count;
    this.data = data.result;
    this.binMerchantProviderList.setParams({
      filterOptions: {
        merchantId: this.merchant.id,
      },
    });
    const providers = await this.binMerchantProviderList.make();

    this.totalRecords = providers.totalNumberOfRows;
    if (!providers.result[this.merchant.id]) this.data = [];
    this.data = providers.result[this.merchant.id];
  }

  actionEmiter(event) {
    switch (event.action) {
      case 'edit':
        this.editProvider(event.key.id, event.key.name);
        break;
      default:
        break;
    }
  }

  async sortChange(event: any) {
    if (event.direction === '') {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction,
      };
    }
    await this.getProviders();
  }

  async editProvider(id: number, name: string) {
    this.router.navigate([`admin/bin-providers/edit/${id}`], {
      state: {
        merchant: {
          id: this.merchant.id,
          name: this.merchant.name
        },
        provider: {
          id: id,
          name: name
        },
      } as PinManagerData,
    });
  }
}
